import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'usb-media-banner',
  templateUrl: './usb-media-banner.component.html',
  styleUrls: ['./usb-media-banner.component.scss']
})
export class UsbMediaBannerComponent {
  /** Gallery images (slot 0, 1, 2). */
  @Input() images: Array<{ thumbnail: string }> = [];
  /** Video items for the third-slot switcher. */
  @Input() videos: Array<{ src: string }> = [];
  /** All media items mixed (image + video) for the selector row. */
  @Input() mediaItems: Array<{ type: 'image' | 'video'; src: string }> = [];
  /** Currently selected media for the third slot. */
  @Input() activeMedia: { type: 'image' | 'video'; src: string } | null = null;
  /** Index of the currently active media in the mediaItems array. */
  @Input() activeMediaIndex: number = -1;
  /** Whether to show placeholders when no images are available. */
  @Input() showPlaceholders: boolean = true;
  /** Total height of the banner in pixels. Side images are half of this. */
  @Input() height: number = 350;
  /** Optional margins to apply to the wrapper. */
  @Input() wrapperMargin: string = '0';

  /** Emitted when the user clicks an image slot (index in images array). */
  @Output() openImage = new EventEmitter<number>();
  /** Emitted when the user clicks a video slot (index in videos array). */
  @Output() openVideo = new EventEmitter<number>();
  /** Emitted when the user clicks a media selector button (index in mediaItems array, plus the media's disabled flag). */
  @Output() selectMedia = new EventEmitter<{ index: number; disabled: boolean }>();
  /** Emitted when the user clicks the "+ de N fotos" text. */
  @Output() seeMorePhotos = new EventEmitter<void>();

  get hasEnoughImages(): boolean {
    return Array.isArray(this.images) && this.images.length >= 3;
  }

  get hasAnyImage(): boolean {
    return Array.isArray(this.images) && this.images.length > 0;
  }

  get sideImageHeight(): number {
    return Math.floor(this.height / 2);
  }

  get remainingPhotosCount(): number {
    return Math.max(0, this.images.length - 1);
  }
}
